"use client";

import classNames from "classnames";
import { Inter } from "next/font/google";
import { trackItemTapped } from "@/utils/mixpanel";
import { MixpanelValues } from "@/constants/mixpanel";

const inter = Inter({ subsets: ["latin"] });

export const TopPlaceTags = ({ tags = [] }) => {
    if (!tags.length) {
        return null;
    }

    return (
        <div
            id="generic-modal-trigger-top-place-tags"
            onClick={() => trackItemTapped(MixpanelValues.ItemTapped.TAGS)}
            className="flex md:flex-wrap gap-1 overflow-x-auto md:overflow-x-hidden">
            {tags.map((tag, index) => {
                return (
                    <span
                        key={index}
                        className={classNames(inter.className, {
                            "font-semibold min-w-max": true,
                            "px-3 py-2 rounded-lg": true,
                            "text-sky-950 md:border md:border-zinc-200 bg-gray-100 md:bg-white": true,
                        })}>
                        {tag}
                    </span>
                );
            })}
        </div>
    );
};
